<template>
  <v-layout row>
    <v-navigation-drawer
      permanent
      absolute
      :style="{ width: '18%', height: '100vh', position: 'fixed'}"
    >
      <v-list :style="{height: '100%'}">
        <v-list-tile avatar @click="$store.dispatch('app/toggleShowLaunchpad')">
          <v-list-tile-action>
            <v-icon>chevron_left</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Launchpad</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          v-for="item in modules"
          :key="item.title"
          @click="handleSettingsChange(item.id)"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <div :style="{position: 'absolute', bottom: '0', width: '100%'}">
          <PermissionsNavigation v-if="activeSetting === 1" />
          <v-list-tile avatar @click="$store.dispatch('app/logout')">
            <v-list-tile-action>
              <v-icon>highlight_off</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </v-list>
    </v-navigation-drawer>

    <PermissionsBody v-if="activeSetting === 1" />
    <InventoryBody v-if="activeSetting === 2" />
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import PermissionsNavigation from "@/components/settings/PermissionsNavigation";
import PermissionsBody from "@/components/settings/PermissionsBody";
import InventoryBody from "@/components/settings/InventoryBody";

export default {
  data() {
    return {
      modules: [
        {
          id: 1,
          title: "Permissions",
          icon: "fa-users"
        },
        {
          id: 2,
          title: "Inventory",
          icon: "fa-warehouse"
        }
      ],
      activeSetting: 1
    };
  },

  components: {
    PermissionsNavigation,
    PermissionsBody,
    InventoryBody
  },

  watch: {},

  computed: {
    ...mapGetters({
      permissions: "settings/getPermissions"
    })
  },
  async mounted() {
    this.activeSetting = 1;
  },
  methods: {
    handleSettingsChange(moduleID) {
      this.activeSetting = moduleID;
    }
  }
};
</script>
